var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2.009 0 4 .002V2H2v8h8V8h2v1.991A2.01 2.01 0 0 1 9.991 12H2.01A2.01 2.01 0 0 1 0 9.991V2.01A2.01 2.01 0 0 1 2.009 0m9 0c.547 0 .991.451.991.99v4.02a.99.99 0 0 1-.883.983L11 6c-.552 0-1-.453-1-.998V3.4L5.993 7.407 4.58 5.993l.707-.707L8.572 2h-1.57a1 1 0 0 1-.995-.883L6 1a1 1 0 0 1 .99-1z"
})));
export default SvgShare;